import { render, staticRenderFns } from "./VinculosContatosForm.vue?vue&type=template&id=159b1195&"
import script from "./VinculosContatosForm.vue?vue&type=script&lang=js&"
export * from "./VinculosContatosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports